import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  container: css`
    & > .MuiButtonBase-root {
      justify-content: flex-start;
    }
    &.MuiInput-underline:after {
      border-bottom: 2px solid ${colors.prussian} !important;
    }
  `,
  optionItem: css`
    padding: 6px 16px !important;
    display: grid !important;
    justify-content: flex-start !important;
  `,
};

export default styles;
